module.exports = __webpack_public_path__ + "img/djibouti.c1801f18.svg";